/**
 * eslint-disable react-hooks/exhaustive-deps
 *
 * @format
 */

import {
  Box,
  Button,
  Checkbox,
  Grid,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DateInput from "../../../components/DateInput";
import SelectBox from "../../../components/SelectBox";
import { NormalTable } from "../../../components/TableCustomize";
import { getClosingDates } from "../../../http/api/BuyerAPI";
import {
  getPaymentConfirmation,
  getPaymentMethods,
  updateWithdrawal,
} from "../../../http/api/PaymentAPI";
import { getHyphenedDate } from "../../../utils/utils";
import { CompanyTitledPage } from "../../TitledPage";
import {
  billingConfirmColumn,
  totalBillingConfirmationColumn,
} from "./enhance";
import { downloadTotalInvoice2 } from "../../../http/api/BillingAPI";
import useInputObject from "../../../hooks/useInputObject";
import PrintPreview from "../../invoice/PrintManagePage/PrintPreview";
import LoadingModal from "../../../components/LoadingModal";

const BillingSearchArea = ({
  onSearchCondition,
  searchConditionInput,
  changeSearchConditionInput,
}) => {
  const onFocusInput = (event) => {
    event.target.select();
  };

  const onClickSearch = (event) => {
    onSearchCondition();
  };

  const handleChangeSearchCondition = (e) => {
    changeSearchConditionInput(e);
  };

  const [paymentMethod, setPaymentMethod] = useState([]);

  const getPaymentMethod = async () => {
    const result = await getPaymentMethods();
    if (result.data) {
      setPaymentMethod(result.data || []);
    }
  };

  useEffect(() => {
    getPaymentMethod();
  }, []);

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      検索
      <Box margin={2}>
        <Grid container alignItems="end" spacing={2}>
          <Grid item xs>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              justifyContent={{ xl: "space-between", lg: "left" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                justifyContent={{ sm: "space-between", md: "left" }}
                width={{ md: "auto", sm: 380 }}
                marginBottom={{ xl: 0, xs: 2 }}
              >
                <Typography>荷主(No/氏名):&nbsp;</Typography>
                <OutlinedInput
                  onFocus={onFocusInput}
                  onChange={({ target: { value } }) =>
                    handleChangeSearchCondition({ keyWord: value })
                  }
                  value={searchConditionInput.keyWord}
                  sx={{ width: 250 }}
                />
              </Stack>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              marginTop={2}
            >
              <Stack direction="row" alignItems="center">
                <Checkbox
                  checked={searchConditionInput.isPayment}
                  onChange={(_e, v) =>
                    handleChangeSearchCondition({ isPayment: v })
                  }
                />
                <Typography>入金ありで絞る</Typography>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Checkbox
                  checked={searchConditionInput.paymentMethod !== "-1"}
                  onChange={(_e, v) => {
                    if (v) {
                      handleChangeSearchCondition({
                        paymentMethod: paymentMethod[0]?.key || "-1",
                      });
                    } else {
                      handleChangeSearchCondition({ paymentMethod: "-1" });
                    }
                  }}
                />
                <Typography>支払い方法で絞る</Typography>
                <Stack>
                  <SelectBox
                    data={paymentMethod}
                    value={searchConditionInput.paymentMethod}
                    onChange={({ target: { value } }) =>
                      handleChangeSearchCondition({ paymentMethod: value })
                    }
                    sx={{ width: 180 }}
                    disabled={searchConditionInput.paymentMethod === "-1"}
                  />
                </Stack>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Checkbox
                  checked={searchConditionInput.isSale}
                  onChange={(_e, v) => {
                    handleChangeSearchCondition({ isSale: v });
                  }}
                />
                <Typography>売上ありで絞る</Typography>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Checkbox
                  checked={searchConditionInput.hasBillingAmount}
                  onChange={(_e, v) => {
                    handleChangeSearchCondition({hasBillingAmount: v});
                  }}
                />
                <Typography>請求額ありで絞る</Typography>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickSearch}>
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default function BillingConfirmation() {
  const [shippingDateInput, setShippingDateInput] = useState(
    getHyphenedDate(new Date())
  );
  const [state, setState] = useState({
    pagination: { page: 0, pageSize: 25, totalPage: 1 },
  });
  const [isLoading, setLoading] = useState(false);

  const [searchConditionInput, setSearchConditionInput] = useState({
    keyWord: "",
    isPayment: false,
    paymentMethod: "-1",
    isSale: false,
    hasBillingAmount: true
  });

  const { pagination } = state;
  const printPreview = useInputObject({
    open: false,
    url: "",
  });

  const [closingDate, setClosingDate] = useState(-1);
  const [closingDateList, setClosingDateList] = useState([]);
  const [totalBillingConfirmationData, setTotalBillingConfirmationData] =
    useState([]);
  const [billingConfirmData, setBillingConfirmData] = useState([]);
  const [selectedPrint, setSelectedPrint] = useState([]);
  const [selectedWithdrawal, setSelectedWithdrawal] = useState([]);
  const [listBuyerNo, setListBuyerNo] = useState([]);

  const updateShippingDate = (shippingDate) => {
    setShippingDateInput(shippingDate);
  };

  const handleChangePageProps = (page) => {
    setState({ ...state, pagination: { ...pagination, page } });
  };

  const onSearchCondition = () => {
    getPaymentConfirmationData({ page: 0 });
  };

  const selectedAll = (value) => {
    let tempArray = [];
    if (value) {
      listBuyerNo.forEach((buyerNo) => {
        if (selectedPrint.map((e) => e.buyerNo).indexOf(buyerNo) === -1) {
          tempArray.push({ buyerNo: buyerNo });
        }
      });
      setSelectedPrint([...selectedPrint, ...tempArray]);
    } else {
      listBuyerNo.forEach((buyerNo) => {
        if (selectedPrint.map((e) => e.buyerNo).indexOf(buyerNo) !== -1) {
          tempArray.push({ buyerNo: buyerNo });
        }
      });
      setSelectedPrint(
        selectedPrint.filter(
          (i) => !tempArray.map((e) => e.buyerNo).includes(i.buyerNo)
        )
      );
    }
  };
  const selected = (value, item) => {
    if (value) {
      setSelectedPrint([...selectedPrint, { buyerNo: item.buyerNo }]);
    } else {
      setSelectedPrint(selectedPrint.filter((i) => i.buyerNo !== item.buyerNo));
    }
  };

  const selectWithdrawal = (value, { buyerNo, withdrawal }) => {
    if (selectedWithdrawal.map((e) => e.buyerNo).includes(buyerNo)) {
      setSelectedWithdrawal(
        selectedWithdrawal.filter((i) => i.buyerNo !== buyerNo)
      );
    } else {
      setSelectedWithdrawal([
        ...selectedWithdrawal,
        { buyerNo, withdrawal, value },
      ]);
    }
  };
  const changeSearchConditionInput = (e) => {
    setSearchConditionInput({
      ...searchConditionInput,
      ...e,
    });
  };

  const handleChangeClosingDate = (e) => {
    setClosingDate(e);
  };

  const getClosingDateList = async () => {
    const closingDateListResponse = await getClosingDates();

    if (closingDateListResponse) {
      setClosingDateList(
        closingDateListResponse.map((closingDateInfo) => ({
          key: closingDateInfo.closingDateCd.toString(),
          value: closingDateInfo.closingDateValue,
        }))
      );
    }
  }

  const getPaymentConfirmationData = async (params = {}) => {
    const param = {
      date: shippingDateInput,
      closingDateCd: closingDate,
      ...searchConditionInput,
      page: pagination.page,
      size: pagination.pageSize,
      ...params,
    };

    const result = await getPaymentConfirmation(param);
    if (result.data) {
      const {
        listTotal,
        results: { items, page, pageSize, totalPage },
        listBuyerNo,
      } = result.data;
      setTotalBillingConfirmationData(
        listTotal.map((i) => {
          i.index = listTotal.indexOf(i);
          return i;
        })
      );
      setBillingConfirmData(items);
      setListBuyerNo(listBuyerNo);
      setState({
        ...state,
        pagination: { ...pagination, page, pageSize, totalPage },
      });
    }
  };
  useEffect(() => {
    getClosingDateList();
  }, []);

  useEffect(() => {
    getPaymentConfirmationData();
  }, [pagination.page, shippingDateInput, closingDate]);

  const printTotalBillOfBuyer = async () => {
    setLoading(true);
    try {
      const request = {
        targetDate: shippingDateInput,
        buyerNos: selectedPrint.map((s) => s.buyerNo),
      };
      const result = await downloadTotalInvoice2(request);

      if (result) {
        const blob = new Blob([result], {
          type: "application/pdf",
          encoding: "UTF-8",
        });
        const fileUrl = URL.createObjectURL(blob);
        printPreview.updates({ open: true, url: fileUrl });
        setSelectedPrint([]);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  const registerDebit = async () => {
    const request = {
      targetDate: shippingDateInput,
      buyerNos: selectedWithdrawal.map((s) => s.buyerNo),
    };

    const result = await updateWithdrawal(request);

    if (result) {
      getPaymentConfirmationData();
      setSelectedWithdrawal([]);
    }
  };

  return (
    <CompanyTitledPage title="請求一覧表確認" hideCurrentTime>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="flex-end"
        marginBottom={2}
      >
        <Grid item xs>
          <Typography sx={{ fontSize: 20, textAlign: "right" }}>
            日付 :
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <DateInput
            value={shippingDateInput}
            setValue={updateShippingDate}
            maxDate={getHyphenedDate(new Date())}
          />
        </Grid>
        <Grid item xs="auto">
          <SelectBox
            data={closingDateList}
            value={closingDate}
            onChange={({ target: { value } }) => handleChangeClosingDate(value)}
            sx={{ width: 200 }}
          />
        </Grid>
      </Grid>
      <BillingSearchArea
        onSearchCondition={onSearchCondition}
        searchConditionInput={searchConditionInput}
        changeSearchConditionInput={changeSearchConditionInput}
      />
      <NormalTable
        data={totalBillingConfirmationData}
        columns={totalBillingConfirmationColumn}
      />
      <Stack direction="row" width={300} justifyContent="space-between">
        <Button
          variant="outlined"
          onClick={printTotalBillOfBuyer}
          disabled={selectedPrint.length < 1}
        >
          請求書印刷
        </Button>
        <PrintPreview printPreview={printPreview} />
        <Button
          variant="contained"
          onClick={registerDebit}
          disabled={selectedWithdrawal.length < 1}
        >
          引落申請登録
        </Button>
      </Stack>
      <NormalTable
        data={billingConfirmData}
        columns={billingConfirmColumn(
          selectedAll,
          selected,
          selectedPrint,
          billingConfirmData,
          selectWithdrawal,
          selectedWithdrawal,
          listBuyerNo
        )}
        pagination={{ ...pagination, handleChangePageProps }}
        paginationTop
      />
      <LoadingModal label="出力中" open={isLoading} />
    </CompanyTitledPage>
  );
}
